import React from 'react';

import style from './Container.module.scss';

interface RowProps {
  tag?: 'div' | 'li';
  children: React.ReactNode;
  className?: string;
  'align-h'?: 'start' | 'center' | 'end' | 'between' | 'around' | 'evenly'; // 수평 정렬 옵션
  'align-v'?: 'start' | 'center' | 'end'; // 수직 정렬 옵션
}

const Row: React.FC<RowProps> = ({
  tag = 'div',
  children,
  className,
  'align-h': alignH,
  'align-v': alignV,
  ...props
}) => {
  const Tag = tag as keyof JSX.IntrinsicElements;
  let alignClass = '';
  if (alignH) {
    alignClass += ` justify-content-${alignH}`;
  }
  if (alignV) {
    alignClass += ` align-items-${alignV}`;
  }
  let containerClass = className ? `${style.row} ${className}` : style.row;
  if (alignClass) containerClass += alignClass;
  return (
    <Tag className={containerClass} {...props}>
      {children}
    </Tag>
  );
};
export default Row;
